import { axios } from '../utilities';
import { PAGINATION } from '../../../shared/constants';

const addOrUpdateRating = rating => axios.put('api/ratings', { rating });

const changeRatingStatus = ratingId => axios.put(`api/ratings/${ratingId}/change-status`);

const getRatingsByUserId = userId => axios.get(`api/ratings/${userId}`);

const deleteRating = ratingId => axios.delete(`api/ratings/${ratingId}`);

const getProjectsFeedbackData = (
  filters,
  { pageIndex, pageSize } = { pageIndex: PAGINATION.pageIndex, pageSize: PAGINATION.pageSize },
  sortBy = null,
  ratingTypes,
  onlyByWriters,
) => axios.get(
  '/api/ratings/data/projects-feedback',
  {
    params: {
      filters,
      pagination: { pageIndex, pageSize },
      sortBy,
      ratingTypes,
      onlyByWriters,
    },
  },
);

const getProjectsFeedbackForExcel = (
  filters,
  sortBy = null,
  ratingTypes,
  onlyByWriters,
) => axios.get(
  '/api/ratings/data/excel-projects-feedback',
  {
    params: {
      filters, sortBy, ratingTypes, onlyByWriters,
    },
  },
);

export default {
  addOrUpdateRating,
  getRatingsByUserId,
  changeRatingStatus,
  deleteRating,
  getProjectsFeedbackData,
  getProjectsFeedbackForExcel,
};
